"use client";

import { useEffect, useState } from "react";
import { useSearchParams, useRouter, usePathname } from "next/navigation";
import { Modal } from "@/components/ui/modal";
import { Button } from "@/components/ui/button";
import { trackSubscriptionCompleted } from "@/lib/analytics";

export function WelcomeProModal() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (searchParams.get("upgraded") === "1") {
      setOpen(true);
      trackSubscriptionCompleted();
      // Clean up the URL without triggering a reload
      router.replace(pathname, { scroll: false });
    }
  }, [searchParams, router, pathname]);

  const handleClose = () => setOpen(false);

  return (
    <Modal open={open} onClose={handleClose} className="max-w-sm text-center">
      <div className="py-4">
        <div className="w-16 h-16 mx-auto mb-5 bg-primary/10 border-2 border-border-thick rounded-xl shadow-brutal-sm flex items-center justify-center">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-primary">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        </div>
        <h2 className="font-display text-2xl font-bold mb-2">Welcome to Pro!</h2>
        <p className="font-body text-sm text-border-thick/60 mb-6 leading-relaxed">
          You now have unlimited uploads, unlimited decks, AI explanations, unlimited tutor chat on every card, and Anki export. Go make something great.
        </p>
        <Button onClick={handleClose} className="w-full">
          Start Studying
        </Button>
      </div>
    </Modal>
  );
}
